export function sortProvisions(a, b) {
  if (a.html_tokens.length <= 0 && b.html_tokens.length <= 0)
    return a.id > b.id ? 1 : -1;

  return (a.html_tokens[0] || Number.NEGATIVE_INFINITY) >
    (b.html_tokens[0] || Number.NEGATIVE_INFINITY)
    ? 1
    : -1;
}
